import { addDoc, collection, deleteDoc, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "firebaseApp";
import { COLLECTIONS } from "firebaseCollections";


export async function replayMessage(message) {
  const { id, hasError, error, ...userMessage } = message;
  try {
    const messagesRef = collection(db, COLLECTIONS.messages);
    const userMessageRef = doc(messagesRef);
    const answerMessageRef = doc(messagesRef);
    const answerMessage = {
      role: "assistant",
      content: "...",
      streaming: true,
      processing: true,
      bookmarked: false,
      cancelled: false,
      botId: userMessage.botId,
      conversationId: userMessage.conversationId,
      uid: userMessage.uid,
      userMessageId: userMessageRef.id,
      createdAt: new Date().getTime(),
    };
    userMessage.answerMessageId = answerMessageRef.id;

    await Promise.all([
      updateDoc(doc(db, "conversations", userMessage.conversationId), {
        processing: true,
      }),
      deleteDoc(doc(db, "messages", id)),
      setDoc(userMessageRef, userMessage),
      setDoc(answerMessageRef, answerMessage),
    ]);
  } catch(error) {
    console.log(error);
    await updateDoc(doc(db, "conversations", userMessage.conversationId), {
      processing: false,
    });
  }
}